module.exports = __webpack_public_path__ + "img/Feature.54fbe881.png";